// --------------------------------------------------------------------------
// #? Show Password - A password block that contains an input field with
//                    an option to toggle password visibility
// --------------------------------------------------------------------------
// Author:      RSPB
// --------------------------------------------------------------------------

'use strict';

module.exports = function (options) {
    var ref = { $root: options.context };

    function init() {
        ref.$password = ref.$root.find('input[type="password"]');

        ref.$root.on('click', '[data-name="show-password"]', function () {
            if (ref.$password.first().attr('type') === 'password') {
                ref.$password.attr('type', 'text');
                // Turning off autocomplete for password field in text mode
                ref.$password.attr('autocomplete', 'off');
            } else {
                ref.$password.attr('type', 'password');
            }
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/show-password.js
// module id = 489
// module chunks = 0